import { Form } from "react-bootstrap";

export function AnioSelect({register, name, onChange, value}) {
    return <Form.Select {...register(name)} onChange={onChange} value={value}>
        <option value="2024">2024</option>
        <option value="2025">2025</option>
        <option value="2026">2026</option>
        <option value="2027">2027</option>
        <option value="2028">2028</option>
        <option value="2029">2029</option>
    </Form.Select>
}